import Button from '@sympla/sympla-components/Button';
import { ANYWHERE_LOCATION_JSON } from 'constants/index';
import { setLocationCookies } from 'utils/setLocationCookies';
import { useGetPathWithLocation } from 'hooks/useGetPathWithLocation';
import locationStore from 'stores/LocationStore';
import addEventToDataLayer from 'components/Integration/addEventToDataLayer';
import { componentTrackingSearch } from 'constants/search';

import * as styles from './ButtonShowMore.css';

function ButtonShowMore() {
  const getPathWithLocation = useGetPathWithLocation();

  const handleClick = () => {
    addEventToDataLayer({
      category: componentTrackingSearch.category,
      label: `${componentTrackingSearch.searchOtherResult}-${componentTrackingSearch.componentButtonShowMore} `,
      action: componentTrackingSearch.actionClick,
    });
    try {
      locationStore?.setSelectedLocation(ANYWHERE_LOCATION_JSON);
      setLocationCookies({ userLocation: ANYWHERE_LOCATION_JSON });
      const query = window?.location?.search ?? '';
      const url = getPathWithLocation({ location: ANYWHERE_LOCATION_JSON });
      if (url) window.location.href = `${url}${query}`;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao navegar:', error);
    }
  };

  return (
    <div className={styles.ButtonShowMoreContainer} data-testid="search-button-show-more-container">
      <Button onClick={handleClick} upperCase={false} data-testid="search-button-show-more">
        Mostrar mais eventos
      </Button>
    </div>
  );
}

export default ButtonShowMore;
